import blurred from '@/img/bg/blurred.jpg';
import bubbles from '@/img/bg/bubbles.jpg';
import chalviri from '@/img/bg/chalviri.jpg';
import chihuahua from '@/img/bg/chihuahua.jpg';
import clouds from '@/img/bg/clouds.jpg';
import cozy from '@/img/bg/cozy.jpg';
import desert from '@/img/bg/desert.jpg';
import dunes from '@/img/bg/dunes.jpg';
import flowers from '@/img/bg/flowers.jpg';
import fog from '@/img/bg/fog.jpg';
import gazelles from '@/img/bg/gazelles.jpg';
import glass from '@/img/bg/glass.jpg';
import holographic from '@/img/bg/holographic.jpg';
import horses from '@/img/bg/horses.jpg';
import iceland from '@/img/bg/iceland.jpg';
import lake from '@/img/bg/lake.jpg';
import memphis from '@/img/bg/memphis.jpg';
import milkyway from '@/img/bg/milkyway.jpg';
import mountaincow from '@/img/bg/mountaincow.jpg';
import mountains from '@/img/bg/mountains.jpg';
import ocean from '@/img/bg/ocean.jpg';
import oceansunset from '@/img/bg/oceansunset.jpg';
import palmleaves from '@/img/bg/palmleaves.jpg';
import pattern from '@/img/bg/pattern.jpg';
import sky from '@/img/bg/sky.jpg';
import sunset from '@/img/bg/sunset.jpg';
import swamp from '@/img/bg/swamp.jpg';
import tree from '@/img/bg/tree.jpg';
import tropical from '@/img/bg/tropical.jpg';
import vineyards from '@/img/bg/vineyards.jpg';
import waterfall from '@/img/bg/waterfall.jpg';
import wave from '@/img/bg/wave.jpg';
import winter from '@/img/bg/winter.jpg';
import zelenci from '@/img/bg/zelenci.jpg';

export default {
  blurred,
  bubbles,
  pattern,
  memphis,
  glass,
  holographic,
  sky,
  iceland,
  oceansunset,
  sunset,
  chalviri,
  clouds,
  desert,
  dunes,
  fog,
  mountaincow,
  chihuahua,
  gazelles,
  horses,
  milkyway,
  lake,
  mountains,
  ocean,
  palmleaves,
  swamp,
  cozy,
  flowers,
  tree,
  tropical,
  vineyards,
  winter,
  waterfall,
  wave,
  zelenci,
};
